<p *ngIf="title.length > 0" class="subtitle mb-0 i-am-already-a-customer"><b>{{title}}</b></p>
<ng-container *ngIf="(config$ | async)?.customerLoginTextTop && ((config$ | async)?.customerLoginTextTop?.length ?? 0) >0">
    <div class="mt-2" [innerHTML]="(config$ | async)?.customerLoginTextTop"></div>
</ng-container>
<div class="field mt-2">
  <label class="label your-email">Ihre E-Mail-Adresse</label>
  <div class="control has-icons-left">
    <input #usernameInput class="input" type="email" placeholder="Benutzername / E-Mail" value="" [(ngModel)]="form.username"/>
    <span class="icon is-small is-left">
      <fa-icon [icon]="faEnvelope"></fa-icon>
    </span>
  </div>
</div>
<div class="field">
  <label class="label your-password">Ihr Passwort</label>
  <div class="control has-icons-left">
    <input class="input" type="password" placeholder="Passwort" value="" [(ngModel)]="form.password"
           (keydown.enter)="setLogin()"/>
    <span class="icon  is-left">
      <fa-icon [icon]="faLock"></fa-icon>
    </span>
  </div>
  <p class="help is-error">
  <p class="login-modal-error" *ngIf="(errorMsg$ | async)">{{(errorMsg$ | async)}}</p>
  <a class="lost-password mt-4" (click)="onClickLostPasswordLink.emit()" routerLink="/user/password-lost">Passwort vergessen?</a>
</div>
<div class="container-submit-button mt-4">
  <iw-shop-forms-submit-button  [formStatus]="formStatus" [classes]="buttonClass" submitLabel="Anmelden"
                              (submit)="setLogin()"></iw-shop-forms-submit-button >
</div>
